import createVideoCardsBiLogger from '@wix/wix-vod-shared/dist/src/common/bi/create-video-cards-bi-logger';
import { logBi } from '../../../../worker/actions/bi';

export default createVideoCardsBiLogger(logBi);
